import React from 'react';
import OrganizersManager from '@/features/cms/components/OrganizersManager';

const CmsOrganizersPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <OrganizersManager />
  </div>
);

export default CmsOrganizersPage;
